module.exports = __webpack_public_path__ + "media/images/icons/paint-brush-icon-437fe5e60a9b6db3da915db45b5c4ba3.svg";